import { useAppSelector } from '@/Application/Hooks/Redux';
import { Skeleton } from '@/modules/perseo-billing/components';
import {
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';

export default function QRContainer({ imageUrl }: Record<string, string>) {
  const { isCencoPayTimeOut } = useAppSelector((state) => state?.billing) || {};

  return (
    <div
      className={`co-mb-6 co-w-[250px] ${
        isCencoPayTimeOut ? 'co-gap-[12px] co-pt-[12px]' : ''
      } co-min-h-[250px] co-rounded-[8px] co-bg-[#F9F9F9] co-flex co-flex-col co-items-center co-justify-center co-relative co-shadow-md`}
    >
      {isCencoPayTimeOut ? (
        <>
          <Icon icon="QRBlurred" />
          <Typography className="co-justify-center co-pb-[20px]">
            El código QR expiró.
          </Typography>
        </>
      ) : (
        <>
          <Icon icon="BorderQR" />
          <div className="co-absolute co-top-0 co-left-0 co-w-full co-h-full co-p-[28px] co-overflow-hidden">
            {imageUrl ? (
              <>
                <img
                  className="co-w-full co-h-full co-rounded-[9px] co-overflow-hidden co-bg-[#F9F9F9]"
                  src={'data:image/png;base64,' + imageUrl}
                  alt=""
                />
              </>
            ) : (
              <div className="co-p-4 co-w-full co-h-full co-bg-[#F9F9F9] co-rounded-[8px] co-shadow-md">
                <Skeleton variant={'rectangular'} />
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
